import styled from 'styled-components/macro';

export const Container = styled.div`
  max-height: 770px;
  overflow: hidden;
`;

export const SmartPhone = styled.div`
  /* The device with borders */
  position: relative;
  width: 360px;
  height: 640px;
  border: 16px black solid;
  border-top-width: 60px;
  border-bottom-width: 60px;
  border-radius: 36px;
  /*  transform: scale(0.8);
  transform-origin: top left;*/

  /* The horizontal line on the top of the device */
  &::before {
    content: '';
    display: block;
    width: 60px;
    height: 5px;
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #333;
    border-radius: 10px;
  }

  /* The circle on the bottom of the device */
  &::after {
    content: '';
    display: block;
    width: 35px;
    height: 35px;
    position: absolute;
    left: 50%;
    bottom: -65px;
    transform: translate(-50%, -50%);
    background: #333;
    border-radius: 50%;
  }
`;

export const Tablet = styled.div`
  position: relative;
  width: 768px;
  height: 1024px;
  border: 16px black solid;
  border-top-width: 60px;
  border-bottom-width: 60px;
  border-radius: 36px;
  transform: scale(0.75);
  transform-origin: top left;

  /* The horizontal line on the top of the device */
  &&::before {
    content: '';
    display: block;
    width: 60px;
    height: 5px;
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #333;
    border-radius: 10px;
  }

  /* The circle on the bottom of the device */
  &::after {
    content: '';
    display: block;
    width: 35px;
    height: 35px;
    position: absolute;
    left: 50%;
    bottom: -65px;
    transform: translate(-50%, -50%);
    background: #333;
    border-radius: 50%;
  }
`;

export const Laptop = styled.div`
  transform-origin: top left;
  transform: scale(
    0.4
  ); /* Scaled down for a better Try-it experience (change to 1 for full scale) */
  width: 1366px;
  height: 800px;
  border-radius: 6px;
  border-style: solid;
  border-color: black;
  border-width: 24px 24px 80px;
  background-color: white;
  margin-left: 110px;

  /* The keyboard of the laptop */
  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 1600px;
    height: 60px;
    margin: 80px 0 0 -110px;
    background: black;
    border-radius: 6px;
  }

  /* The top of the keyboard */
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 250px;
    height: 30px;
    bottom: -110px;
    left: 50%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
    background: #f1f1f1;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
  }
`;
